import { defineStore } from "pinia";

interface FlashMessage {
  message: string;
  type: string;
}

export const useFlashStore = defineStore("flash", {
  persist: {
    storage: localStorage,
  },
  state: (): { flashMessages: FlashMessage[] } => ({
    flashMessages: [],
  }),
  actions: {
    setFlashMessages(messages: FlashMessage | FlashMessage[]) {
      this.flashMessages = Array.isArray(messages) ? messages : [messages];
    },
    clearFlashMessages() {
      this.flashMessages = [];
    },
  },
  getters: {},
});
